module.exports = __webpack_public_path__ + "static/img/guide-26.40bb5d8d.png";